import classNames from 'classnames';
import { differenceInCalendarDays } from 'date-fns';
import { isString } from 'lodash-es';
import { Tooltip } from './tooltip';

type DateProps = {
  date: string | null;
  className?: string;
};

type FormattedDateProps = DateProps & {
  dateFormat: Intl.DateTimeFormat;
};

const FormattedDate = ({ date, className, dateFormat }: FormattedDateProps) => {
  if (!isString(date)) {
    return null;
  }

  return (
    <time dateTime={date} className={classNames(className)}>{dateFormat.format(new Date(date))}</time>
  );
};

const shortDateFormat = new Intl.DateTimeFormat('de-de', { year: 'numeric', month: '2-digit', day: '2-digit' });
export const formatShortDate = (date: string) => isString(date) ? shortDateFormat.format(new Date(date)) : date;
export const ShortDate = (props: DateProps) => <FormattedDate {...props} dateFormat={shortDateFormat} />;

const shortTimeFormat = new Intl.DateTimeFormat('de-de', { hour: '2-digit', minute: '2-digit' });
export const formatShortTime = (date: string) => isString(date) ? shortTimeFormat.format(new Date(date)) : date;
export const ShortTime = (props: DateProps) => <FormattedDate {...props} dateFormat={shortTimeFormat} />;

const dateTimeFormat = new Intl.DateTimeFormat('de-de', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
export const formatDateTime = (date: string) => isString(date) ? dateTimeFormat.format(new Date(date)) : date;
export const DateTime = (props: DateProps) => <FormattedDate {...props} dateFormat={dateTimeFormat} />;


const relativeDateFormat = new Intl.RelativeTimeFormat('de-de', { style: 'short', numeric: 'auto' });

type FormattedRelativeDateProps = DateProps;

export const RelativeDate = ({ date, className }: FormattedRelativeDateProps) => {
  if (!isString(date)) {
    return null;
  }

  const days = differenceInCalendarDays(new Date(date), new Date());

  return (
    <Tooltip content={shortDateFormat.format(new Date(date))}>
      <time dateTime={date} className={classNames(className)}>{relativeDateFormat.format(days, 'days')}</time>
    </Tooltip>
  );
};
